import React from "react";

export const BranchAssignmentDetailContext = React.createContext(null);

export const useBranchAssignmentContext = () => {
  const context = React.useContext(BranchAssignmentDetailContext);

  if (!context)
    throw new Error("Branch Assignment Detail Context not provided!");

  return context;
};
